import {Component, AfterViewInit, ElementRef, Renderer, ViewChild, OnDestroy} from '@angular/core';
import {ScrollPanel} from 'primeng/primeng';
import { UserService } from './services/user.service';
import { environment } from '../environments/environment';
import {GoogleMapsLoaderService} from './services/google-maps-loader.service';

enum MenuOrientation {
  STATIC,
  OVERLAY,
  SLIM,
  HORIZONTAL
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit {

  layoutMode: MenuOrientation = MenuOrientation.STATIC;

  darkMenu = true;

  profileMode = 'inline';

  rotateMenuButton: boolean;

  topbarMenuActive: boolean;

  overlayMenuActive: boolean;

  staticMenuDesktopInactive: boolean;

  staticMenuMobileActive: boolean;

  layoutMenuScroller: HTMLDivElement;

  menuClick: boolean;

  topbarItemClick: boolean;

  activeTopbarItem: any;

  resetMenu: boolean;

  menuHoverActive: boolean;

  @ViewChild('layoutMenuScroller') layoutMenuScrollerViewChild: ScrollPanel;

  constructor(public renderer: Renderer, public userService:UserService, private mapsLoader: GoogleMapsLoaderService) {
  }

  ngAfterViewInit() {
    //setTimeout(() => {this.layoutMenuScrollerViewChild.moveBar(); }, 100);
  }

  ngOnInit() {
    this.mapsLoader.load().then(() => {
      console.log('Google Maps API cargado');
    });
    /*if (environment.production) {
      if (location.protocol === 'http:') {
        window.location.href = location.href.replace('http', 'https');
      }
    }*/
    if(window.location.href.indexOf("monitoring") > 0){
      this.userService.monitoring = true;
    }else{
      this.userService.monitoring = false;
    }
  }

  isLogged(): boolean{
    return this.userService.userLoged != null;
  }

  onLayoutClick() {
    if (!this.topbarItemClick) {
      this.activeTopbarItem = null;
      this.topbarMenuActive = false;
    }

    if (!this.menuClick) {
      if (this.isHorizontal() || this.isSlim()) {
        this.resetMenu = true;
      }

      if (this.overlayMenuActive || this.staticMenuMobileActive) {
        this.hideOverlayMenu();
      }

      this.menuHoverActive = false;
    }

    this.topbarItemClick = false;
    this.menuClick = false;
  }

  onMenuButtonClick(event) {
    this.menuClick = true;
    this.rotateMenuButton = !this.rotateMenuButton;
    this.topbarMenuActive = false;

    if (this.layoutMode === MenuOrientation.OVERLAY) {
      this.overlayMenuActive = !this.overlayMenuActive;
    } else {
      if (this.isDesktop()) {
        this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive; } else {
          this.staticMenuMobileActive = !this.staticMenuMobileActive; }
        }

        event.preventDefault();
      }

      onMenuClick($event) {
        this.menuClick = true;
        this.resetMenu = false;

        if (!this.isHorizontal()) {
          //setTimeout(() => {this.layoutMenuScrollerViewChild.moveBar(); }, 450);
        }
      }

      onTopbarMenuButtonClick(event) {
        this.topbarItemClick = true;
        this.topbarMenuActive = !this.topbarMenuActive;

        this.hideOverlayMenu();

        event.preventDefault();
      }

      onTopbarItemClick(event, item) {
        this.topbarItemClick = true;

        if (this.activeTopbarItem === item) {
          this.activeTopbarItem = null; } else {
            this.activeTopbarItem = item; }

            event.preventDefault();
          }

          hideOverlayMenu() {
            this.rotateMenuButton = false;
            this.overlayMenuActive = false;
            this.staticMenuMobileActive = false;
          }

          isTablet() {
            const width = window.innerWidth;
            return width <= 1024 && width > 640;
          }

          isDesktop() {
            return window.innerWidth > 1024;
          }

          isMobile() {
            return window.innerWidth <= 640;
          }

          isOverlay() {
            return this.layoutMode === MenuOrientation.OVERLAY;
          }

          isHorizontal() {
            return this.layoutMode === MenuOrientation.HORIZONTAL;
          }

          isSlim() {
            return this.layoutMode === MenuOrientation.SLIM;
          }

          changeToStaticMenu() {
            this.layoutMode = MenuOrientation.STATIC;
          }

          changeToOverlayMenu() {
            this.layoutMode = MenuOrientation.OVERLAY;
          }

          changeToHorizontalMenu() {
            this.layoutMode = MenuOrientation.HORIZONTAL;
          }

          changeToSlimMenu() {
            this.layoutMode = MenuOrientation.SLIM;
          }

        }



// WEBPACK FOOTER //
// ./src/app/app.component.ts